import React from 'react';
import cn from 'classnames';
import { IReview } from 'mod/review/interface';
import { Rate } from '@base/lib/Rate';
import { PreviewThumb } from '@base/snippets/PreviewThumb';
import { IPreviewerRenderProps } from '@base/lib/ImagePreviewer';

type IProps = IPreviewerRenderProps & {
    review: IReview;
    className?: string;
}

export const ReviewItemPC: React.FC<IProps> = (props) => {
    const { review, open, className } = props

    return (
        <div className={cn(className, 'g-review-item flex')} data-id={review?.id}>
            <div className={'g-col1'}>
                <p className={'g-name'}>{review.username}</p>
                {review.optionValue.map(opt => (
                    <p className={'g-attr'} key={opt.optionValueId}>
                        {opt.optionName ? `${opt.optionName}: ` : ''}
                        <span className="text-muted">{opt.optionValueName}</span>
                    </p>
                ))}
            </div>
            <div className={'g-col2'}>
                <div className={'g-col2-1'}>
                    <Rate value={review.score || 5.0} starSize={15}/>
                    <p className={'g-title'}>
                        {review.reviewTitle}
                    </p>
                    <p className={'g-content'}>
                        {review.reviewInfo}
                    </p>
                </div>
                <div className={'g-col2-2'}>
                    <ul className={'g-assets'}>
                        {review.reviewAsset.map((raItem, raIndex) => (
                            <PreviewThumb
                                className={'g-asset'}
                                key={raIndex}
                                url={raItem.link}
                                width={108}
                                height={108}
                                onClick={() => open({
                                    list: review.reviewAsset.map(item => item.link),
                                    activeIndex: raIndex
                                })}
                            />
                        ))}
                    </ul>
                </div>
            </div>
            <div className={'g-col3'}>{review.updateTime}</div>
        </div>
    )
}